import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { FillingStationIssueModel } from '../../../api/fillingstationissue/fillingstationissue';
import { FillingStationIssueService } from '../../../api/fillingstationissue/fillingstationissue.service';
declare var $: any;
declare var jQuery: any;
declare var swal: any;
@Component({
    selector: 'fillingstationissue-page',
    templateUrl: './fillingstationissue.html'
})
export class FillingStationIssueComponent implements OnInit {
    issueList: FillingStationIssueModel[];
    issue: FillingStationIssueModel;
    id: string;
    i: number;
    filterisresolve : string = "0";

    message : string = "";
    county : string = "";
    name : string = "";
    address : string = "";
    location : string = "";

    constructor(private fillingStationIssueService: FillingStationIssueService, private router: Router) {
    }
    ngOnInit() {
        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN' || localStorage.getItem('type') == 'ADMIN' ||  localStorage.getItem('type') == 'GENEROSITY')) {
            $(function () {
            });
            this.filterisresolve = "0";
            this.initFillingStationIssue();
        } else {
            this.router.navigate(['/']);
        }
    }
    initFillingStationIssue() {
        var rrData = {
            isresolve : this.filterisresolve
        }
        this.fillingStationIssueService
            .allData(rrData)
            .then(
                data => {
                    this.issueList = data
                }
            );
    }
    cancelAction() 
    {

    }
    showAdmin(issue, i) {
        this.i = i;
        this.issue = issue;
        this.id = issue.id;
    }
    updateAdmin() {
        // if (this.password == "" || this.password == null || this.password == undefined) {
        //     $.notify({
        //         message: "Please Enter Password"
        //     }, {
        //         type: 'danger',
        //         placement: {
        //             from: 'bottom',
        //             align: 'left'
        //         },
        //         delay: 100,
        //         timer: 100
        //     });
        //     this.cancelAction()
        //     return;
        // }
        // var uRegister = {
        //     email: this.emailId,
        //     mobile: this.mobileno,
        //     password: this.password,
        //     role: this.userType,
        //     updatedById: this.thisUserId
        // }
        // this.registerService
        //     .uAdmin(this.id, uRegister)
        //     .then(data => {
        //         if (data.status == true) {
        //             this.message = data.message
        //             this.initRegister();
        //             $.notify({
        //                 message: this.message
        //             }, {
        //                 type: 'success',
        //                 placement: {
        //                     from: 'bottom',
        //                     align: 'left'
        //                 },
        //                 delay: 100,
        //                 timer: 100
        //             });
        //             this.cancelAction()
        //             $(function () {
        //                 $('#exampleModal').modal('toggle');
        //             });
        //         } else {
        //             this.message = data.message
        //             $.notify({
        //                 message: this.message
        //             }, {
        //                 type: 'danger',
        //                 placement: {
        //                     from: 'bottom',
        //                     align: 'left'
        //                 },
        //                 delay: 100,
        //                 timer: 100
        //             });
        //         }
        //     });
    }
    ExternalMapLocation(lati,longi)
    {
        window.open("https://maps.google.com/?q="+lati+","+longi, "_blank");
    }
    onFilterStatusChange(filStatus)
    {
        this.filterisresolve = filStatus
        this.initFillingStationIssue();
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/fillingstationissue/fillingstationissue.page.ts